import { Grid, TextField } from "@material-ui/core";
import React, { FC } from "react";
import { RoomViewModel } from "../../model/RoomViewModel";
import CustomSwitch from "../common/CustomSwitch";
import FormGridCell from "../common/FormGridCell";
import { useIntl } from "react-intl";
import { GetTranslation } from "../../translations/GetTranslation";

interface RoomFieldsProps {
  room: RoomViewModel;
  onPropertyValueChanges?: (part: Partial<RoomViewModel>) => void;
}

const RoomFields: FC<RoomFieldsProps> = ({ room, onPropertyValueChanges }) => {
  const intl = useIntl();

  const handleTextChange =
    (key: keyof RoomViewModel) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
      handleChange(key, event.target.value);

  const handleIdPCRoomChange = (value: boolean) => handleChange("isPcRoom", value);

  const handleNumberOfSeatsChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    handleChange("numberOfSeats", parseInt(event.target.value));

  const handleChange = (key: keyof RoomViewModel, value: unknown) => {
    let partialRoom: Partial<RoomViewModel> = {
      [key]: value,
    };
    onPropertyValueChanges!(partialRoom);
  };

  return (
    <Grid container={true} spacing={1}>
      <FormGridCell size="full">
        <TextField
          fullWidth={true}
          label={GetTranslation(intl, "room.field.name")}
          value={room.name}
          onChange={handleTextChange("name")}
        />
      </FormGridCell>
      <FormGridCell size="fill" />
      <FormGridCell size="full">
        <TextField
          fullWidth={true}
          label={GetTranslation(intl, "room.field.floor")}
          value={room.floor}
          onChange={handleTextChange("floor")}
        />
      </FormGridCell>
      <FormGridCell size="fill" />
      <FormGridCell size="half">
        <CustomSwitch
          label={GetTranslation(intl, "room.field.isPcRoom")}
          onChange={handleIdPCRoomChange}
          value={room.isPcRoom}
        />
      </FormGridCell>
      <FormGridCell size="half">
        <TextField
          fullWidth={true}
          label={GetTranslation(intl, "room.field.numberOfSeats")}
          type="number"
          inputProps={{ min: 1 }}
          value={room.numberOfSeats}
          onChange={handleNumberOfSeatsChange}
        />
      </FormGridCell>
      <FormGridCell size="fill" />
    </Grid>
  );
};

export default RoomFields;
